/** @jsx jsx */
import { jsx } from "theme-ui"
import React from "react"
import get from "lodash/get"
import {
  Radio,
  Label,
  Input,
  Select,
  Textarea,
  Button,
  Spinner,
} from "@theme-ui/components"
import { useForm } from "react-hook-form"
import queryString from "query-string"
import PropTypes from "prop-types"

import Container from "./container"
import Row from "./row"
import Column from "./column"
import Text from "./text"
let textStates = {};
const Form = ({
  children,
  customStyle,
  formData,
  onSubmit,
  onSuccess,
  noSteps,
  type,
  moveToTopOnSubmit,
}) => {
  const [stepState, setStepState] = React.useState({
    step: 0,
    route: formData.defaultRoute,
    basicDetailsSet: noSteps ? true : false,
    sending: false,
    processing: false,
    sent: false,
    data: {},
    textarray: []
  })

  const setCharCount = (e, id) => {
    textStates[id] = e.target.value.length;
  }



  const { register, handleSubmit, watch, errors } = useForm({
    mode: "onChange",
    submitFocusError: false,
  })

  const watches = watch(["form"])
  const validateQuestionCondition = (question, data) =>
    question.conditionQuestion
      ? question.conditionAnswers.includes(
        get(data ? data : watches, `form._${question.conditionQuestion}`)
      )
      : true
  let currentQuestions = get(
    formData.routes,
    `${stepState.route}.questions`,
    []
  ).map(question => (validateQuestionCondition(question) ? question : null))
  if (!noSteps)
    currentQuestions = currentQuestions.slice(
      0,
      stepState.step >= 0 ? stepState.step + 1 : 0
    )
  const lastCurrentQuestion = currentQuestions[currentQuestions.length - 1]
  const isLastQuestion = stepState.route
    ? formData.routes[stepState.route].questions[
    formData.routes[stepState.route].questions.length - 1
    ] === lastCurrentQuestion
    : false



  const renderSelectionButton = (buttonType, currentType, handler) => {
    return (
      <Button
        variant="forms.buttonSelection"
        onClick={() => {
          handler(buttonType)
        }}
        type="button"
        sx={{
          bg: () => (currentType === buttonType ? "primary" : "secondary"),
          textAlign: "left",
        }}
      >
        {buttonType}
      </Button>
    )
  }
  const renderBasicQuestions = () => {
    const styles = {
      label:
        type === "secondary"
          ? {
            mb: 1,
            mt: type === "secondary" ? 3 : 0,
            fontSize: 2,
            fontWeight: "bold",
          }
          : { mb: 1 },
    }
    return (
      <Row customStyle={{ mb: 4 }}>
        <Column size={type === "secondary" ? [12, 12, 6, 6] : [12, 12, 6, 4]}>
          <Label sx={{ ...styles.label }}>First Name</Label>
          <Input
            name="form.basicDetails.firstName"
            ref={register({
              required: "required",
            })}
            variant={
              get(errors, "form.basicDetails.firstName")
                ? "forms.inputError"
                : "forms.input"
            }
          />
        </Column>
        <Column size={type === "secondary" ? [12, 12, 6, 6] : [12, 12, 6, 4]}>
          <Label sx={{ ...styles.label }}>Last Name</Label>
          <Input
            name="form.basicDetails.lastName"
            ref={register({
              required: "required",
            })}
            variant={
              get(errors, "form.basicDetails.lastName")
                ? "forms.inputError"
                : "forms.input"
            }
          />
        </Column>
        <Column size={type === "secondary" ? [12, 12, 6, 6] : [12, 12, 6, 4]}>
          <Label sx={{ ...styles.label }}>Email Address</Label>
          <Input
            name="form.basicDetails.email"
            ref={register({
              required: "required",
              pattern: /^\S+@\S+$/i,
            })}
            variant={
              get(errors, "form.basicDetails.email")
                ? "forms.inputError"
                : "forms.input"
            }
          />
        </Column>
      </Row>
    )
  }
  const renderQuestion = question => {
    let name = `form._${question.id}`
    return (
      <Row customStyle={{ mb: 4 }}>
        <Column size={[12, 12, 12]}>
          {question.question && (
            <Text type="h3" customStyle={{ mb: 2 }}>
              {question.question}
            </Text>
          )}
        </Column>
        <Column size={[12, 12, 12]}>
          {question.type === "input" ? (
            <Input
              name={name}
              {...(question.required
                ? {
                  ref: register({
                    required: "required",
                  }),
                  variant: get(errors, name)
                    ? "forms.inputError"
                    : "forms.input",
                }
                : { ref: register({}) })}
            />
          ) : null}
          {question.type === "phone" ? (
            <Input
              name={name}
              {...(question.required
                ? {
                  ref: register({
                    required: "required",
                    minLength: 10,
                    pattern: /^[0-9+()-].+$/i,
                  }),
                  variant: get(errors, name)
                    ? "forms.inputError"
                    : "forms.input",
                }
                : {
                  ref: register({ minLength: 10, pattern: /^[0-9.].+$/i }),
                })}
            />
          ) : null}
          {question.type === "price" ? (
            <>
              <Text type="h4" customStyle={{ my: 2 }}>
                Price Per Square Foot $
              </Text>
              <Input
                name={name}
                {...(question.required
                  ? {
                    ref: register({
                      required: "required",
                      pattern: /^[0-9.].+$/i,
                    }),
                    variant: get(errors, name)
                      ? "forms.inputError"
                      : "forms.input",
                  }
                  : { ref: register({ pattern: /^[0-9.].+$/i }) })}
              />
            </>
          ) : null}
          {question.type === "location" ? (
            <Row>
              <Column size={[12, 12, 12, 12]}>
                <Label sx={{ mb: 1 }}>Country</Label>
                <Select
                  name={`${name}.country`}
                  ref={register({
                    required: "required",
                  })}
                  defaultValue="US"
                >
                  <option value="US">United States</option>
                </Select>
              </Column>
              <Column size={[12, 12, 12, 12]}>
                <Label sx={{ mb: 1 }}>Street</Label>
                <Input
                  name={`${name}.address`}
                  ref={register({})}
                  variant={
                    get(errors, `${name}.address`)
                      ? "forms.inputError"
                      : "forms.input"
                  }
                />
              </Column>
              <Column size={[12, 12, 6, 4]}>
                <Label sx={{ mb: 1 }}>City</Label>
                <Input
                  name={`${name}.city`}
                  ref={register({
                    required: "required",
                  })}
                  variant={
                    get(errors, `${name}.city`)
                      ? "forms.inputError"
                      : "forms.input"
                  }
                />
              </Column>
              <Column size={[12, 12, 6, 4]}>
                <Label sx={{ mb: 1 }}>State</Label>
                <Select
                  name={`${name}.state`}
                  ref={register({
                    required: "required",
                    validate: value => value !== "_",
                  })}
                  variant={
                    get(errors, `${name}.state`)
                      ? "forms.selectError"
                      : "forms.select"
                  }
                  defaultValue="_"
                >
                  <option value="_" disabled>
                    {formData.dropdownPlaceholderText}
                  </option>
                  <option value="AL">Alabama</option>
                  <option value="AK">Alaska</option>
                  <option value="AZ">Arizona</option>
                  <option value="AR">Arkansas</option>
                  <option value="CA">California</option>
                  <option value="CO">Colorado</option>
                  <option value="CT">Connecticut</option>
                  <option value="DE">Delaware</option>
                  <option value="DC">District Of Columbia</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="HI">Hawaii</option>
                  <option value="ID">Idaho</option>
                  <option value="IL">Illinois</option>
                  <option value="IN">Indiana</option>
                  <option value="IA">Iowa</option>
                  <option value="KS">Kansas</option>
                  <option value="KY">Kentucky</option>
                  <option value="LA">Louisiana</option>
                  <option value="ME">Maine</option>
                  <option value="MD">Maryland</option>
                  <option value="MA">Massachusetts</option>
                  <option value="MI">Michigan</option>
                  <option value="MN">Minnesota</option>
                  <option value="MS">Mississippi</option>
                  <option value="MO">Missouri</option>
                  <option value="MT">Montana</option>
                  <option value="NE">Nebraska</option>
                  <option value="NV">Nevada</option>
                  <option value="NH">New Hampshire</option>
                  <option value="NJ">New Jersey</option>
                  <option value="NM">New Mexico</option>
                  <option value="NY">New York</option>
                  <option value="NC">North Carolina</option>
                  <option value="ND">North Dakota</option>
                  <option value="OH">Ohio</option>
                  <option value="OK">Oklahoma</option>
                  <option value="OR">Oregon</option>
                  <option value="PA">Pennsylvania</option>
                  <option value="RI">Rhode Island</option>
                  <option value="SC">South Carolina</option>
                  <option value="SD">South Dakota</option>
                  <option value="TN">Tennessee</option>
                  <option value="TX">Texas</option>
                  <option value="UT">Utah</option>
                  <option value="VT">Vermont</option>
                  <option value="VA">Virginia</option>
                  <option value="WA">Washington</option>
                  <option value="WV">West Virginia</option>
                  <option value="WI">Wisconsin</option>
                  <option value="WY">Wyoming</option>
                </Select>
              </Column>
              <Column size={[12, 12, 6, 4]}>
                <Label sx={{ mb: 1 }}>Zip</Label>
                <Input
                  name={`${name}.zip`}
                  ref={register({
                    required: "required",
                    pattern: /^[0-9].+$/i,
                  })}
                  variant={
                    get(errors, `${name}.zip`)
                      ? "forms.inputError"
                      : "forms.input"
                  }
                />
              </Column>
            </Row>
          ) : null}
          {question.type === "textarea" ? (
            <React.Fragment>
              <Textarea
                name={name}
                {...(question.required
                  ? {
                    ref: register({
                      required: "required",
                    }),
                    variant: get(errors, name)
                      ? "forms.textareaError"
                      : "forms.textarea",
                  }
                  : { ref: register({}) })}
                onChange={e => setCharCount(e, question.id)}
              />
              <span style={{
                fontWeight: 600, color: textStates && textStates[question.id] && textStates[question.id] > 500 ? 'red' : 'black', paddingLeft: '8px',
                fontFamily: 'Helvetica Neue,sans-serif'
              }}>{textStates && textStates[question.id] ? textStates[question.id] : 0}/500</span>
            </React.Fragment>
          ) : null}



          {question.type === "select" ? (
            <Select
              defaultValue={question.defaultAnswer || "_"}
              name={name}
              ref={register({
                required: true,
                validate: value => value !== "_",
              })}
              variant={get(errors, name) ? "forms.selectError" : "forms.select"}
            >
              {!question.defaultAnswer && (
                <option value="_" disabled>
                  {formData.dropdownPlaceholderText}
                </option>
              )}
              {question.answers.map((answer, index) => (
                <option key={index} value={answer.value}>
                  {answer.text}
                </option>
              ))}
            </Select>
          ) : null}
          {question.type === "radio"
            ? question.answers.map((option, index) => (
              <Label key={index}>
                <Radio
                  name={name}
                  value={option.value}
                  {...(option.value === question.defaultAnswer
                    ? { defaultChecked: "checked" }
                    : {})}
                  ref={register({ required: true })}
                />
                {option.text}
              </Label>
            ))
            : null}
        </Column>
      </Row>
    )
  }
  const renderRouteSelector = () => (
    <Row customStyle={{ mb: 4 }}>
      <Column size={[12, 12, 12]}>
        <Text type="h3" customStyle={{ mb: 2 }}>
          What best describes you?
        </Text>
      </Column>
      <Row
        customStyle={{
          mx: 1,
          width: "100%",
        }}
      >
        {Object.keys(formData.routes)
          .sort((a, b) => formData.routes[a].order - formData.routes[b].order)
          .map((buttonType, index) => (
            <Column
              key={index}
              size={[12, 6, 4, 3]}
              customStyle={{
                flexWrap: "wrap",
                my: 2,
                pl: "6px",
                maxWidth: [
                  "100%",
                  "50%",
                  type === "secondary" ? `${100 / 3}%` : "25%",
                  type === "secondary" ? `${100 / 3}%` : "20%",
                ],
                flexBasis: [
                  "100%",
                  "50%",
                  type === "secondary" ? `${100 / 3}%` : "25%",
                  type === "secondary" ? `${100 / 3}%` : "20%",
                ],
              }}
            >
              {renderSelectionButton(buttonType, stepState.route, changeRoute)}
            </Column>
          ))}
      </Row>
    </Row>
  )

  const doNextStep = data => {
    if (!stepState.basicDetailsSet) {
      setStepState({ ...stepState, basicDetailsSet: true })
    } else if (stepState.route) {
      let nextStep = stepState.step + 1
      while (
        nextStep < formData.routes[stepState.route].questions.length &&
        !validateQuestionCondition(
          formData.routes[stepState.route].questions[nextStep],
          data
        )
      ) {
        nextStep++
      }
      setStepState({ ...stepState, step: nextStep })
    }
  }
  const changeRoute = type => {
    setStepState({ ...stepState, step: 0, route: type })
  }
  const checkIsLastQuestion = async data => {
    let isMax = false;
    for (let char in textStates) {
      if (textStates[char] > 500) isMax = true;
    }
    if (isMax) return;
    if (isLastQuestion && data.form) {
      if (moveToTopOnSubmit)
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" })
      setStepState({ ...stepState, sending: true, data })
    } else {
      doNextStep(data)
    }
  }

  React.useLayoutEffect(() => {
    const submitGA = () => {
      window &&
        window.gtag &&
        window.gtag("event", "Form submission", {
          event_label: formData.gaEventLabel,
          event_category: "Event",
          non_interaction: true,
        })

      /* For google converion apis */

      // window &&
      //   window.gtag && window.gtag('event', 'conversion', {
      //     'send_to': 'AW-799114647/AW-rtBBCL6J-dQBEJeLhv0C',
      //     'value': 1.0,
      //     'currency': 'USD'
      //   });
      // window &&
      //   window.gtag && window.gtag('config', 'AW-799114647');
    }
    const sendForm = async data => {
      let requestData = {
        ...formData.defaultFields,
      }
      const referralLink =
        type === "secondary"
          ? window.location.href
          : queryString.parse(window.location.search).ref
      if (formData.referralLinkField && referralLink) {
        requestData[formData.referralLinkField] = referralLink
      }
      if (formData.basicQuestions)
        requestData = {
          ...requestData,
          first_name: data.form.basicDetails.firstName,
          last_name: data.form.basicDetails.lastName,
          email: data.form.basicDetails.email,
        }
      for (const question of currentQuestions) {
        if (question && question.id) {
          const answer = get(data, `form._${question.id}`)
          if (answer && question.type !== "location") {
            requestData[question.fieldName] = answer
          } else if (answer) {
            requestData.state = get(data, `form._${question.id}.state`)
            requestData.city = get(data, `form._${question.id}.city`)
            requestData.address = get(data, `form._${question.id}.address`)
            requestData.country = get(data, `form._${question.id}.country`)
            requestData.zip = get(data, `form._${question.id}.zip`)
          }
        }
      }
      if (formData.routes[stepState.route].hiddenFields) {
        requestData = {
          ...requestData,
          ...formData.routes[stepState.route].hiddenFields,
        }
      }
      if (onSubmit) onSubmit(requestData)
      submitGA()
      textStates = {}
      let response
      if (formData.method === "GET") {
        response = await fetch(
          queryString.stringifyUrl(
            { url: formData.url, query: requestData },
            { encode: true, sort: false }
          ),
          {
            method: "GET",
          }
        )
      }
      if (response.status === 200) {
        if (onSuccess) onSuccess(requestData)
        setStepState({ ...stepState, sending: false, sent: true })
      }
    }
    if (stepState.sending && !stepState.processing) {
      sendForm(stepState.data)
      setStepState({ ...stepState, processing: true })
    }
  }, [stepState, currentQuestions, formData, onSubmit, onSuccess, type])

  return (
    <Container customStyle={{ ...customStyle }}>
      {!(stepState.sent || stepState.sending) ? children : null}
      {stepState.sent ? (
        <Text type="h2">{formData.thankYouMessage}</Text>
      ) : stepState.sending ? (
        <Spinner />
      ) : (
            <form onSubmit={handleSubmit(checkIsLastQuestion)}>
              {formData.basicQuestions ? renderBasicQuestions() : null}
              {stepState.basicDetailsSet && Object.keys(formData.routes).length > 1
                ? renderRouteSelector()
                : null}
              {currentQuestions.map((question, index) => (
                <div key={index}>{question && renderQuestion(question)}</div>
              ))}
              {!stepState.basicDetailsSet ? (
                <Button type="submit" variant="forms.buttonChevron">
                  {formData.initialButtonText}
                </Button>
              ) : null}
              {stepState.basicDetailsSet &&
                stepState.route &&
                type !== "secondary" ? (
                  <Button type="submit" variant="forms.buttonChevron">
                    {isLastQuestion
                      ? formData.submitButtonText
                      : formData.nextButtonText}
                  </Button>
                ) : null}
              {type === "secondary" ? (
                <Button
                  type="submit"
                  variant="forms.buttonChevron"
                  sx={{ background: stepState.route ? null : "#888" }}
                  disabled={!stepState.route}
                >
                  {formData.submitButtonText}
                </Button>
              ) : null}
            </form>
          )}
    </Container>
  )
}
Form.propTypes = {
  children: PropTypes.node,
  customStyle: PropTypes.object,
  formData: PropTypes.object,
  onSubmit: PropTypes.func,
  onSuccess: PropTypes.func,
}
export default Form
